import moment from "moment";
import { AthleteDTO } from "../interfaces/AthletesDTO";
import { TimeDTO } from "../interfaces/TimeDTO";
import { formatTime } from "./timeHandler";

export function GetTopResults(
  inp: TimeDTO[],
  ath: AthleteDTO,
  ipos: number
): (TimeDiffDTO | null)[] {
  let tim = inp.filter((o) => o.AthleteID === ath.ID);
  if (tim.length < 1) {
    return [];
  }
  let athTime = tim[0];
  let tims = [
    GetTime(1, inp, athTime),
    GetTime(3, inp, athTime),
    GetTime(5, inp, athTime),
    GetTime(10, inp, athTime),
    GetTime(15, inp, athTime),
    GetTime(20, inp, athTime),
    GetTime(30, inp, athTime),
    GetTime(40, inp, athTime),
    GetTime(50, inp, athTime),
    GetTime(60, inp, athTime),
    GetTime(70, inp, athTime),
    GetTime(80, inp, athTime),
  ];

  let timeMSValues = tims.map(o =>  o?.timeMS).filter(o => o != null) as number[];

  // Find the minimum timeMS
  let minTimeMS = Math.min(...timeMSValues);

  // If you need to return the entire object with the minimum timeMS
  let minTimeObject = tims.find(o => o?.timeMS === minTimeMS) || null;
  if (minTimeObject){
    minTimeObject.closest = true;
  }
  return tims;
}
function GetTime(
  rnk: number,
  times: TimeDTO[],
  selrtime: TimeDTO
): TimeDiffDTO | null {
  let selTim = times.filter((o) => o.RankClass >= rnk);
  if (selTim.length < 1) {
    return null;
  }

  // Convert time string to a moment object
  const formatTimeToMoment = (timeStr: string) =>
    moment(timeStr, "HH:mm:ss.SSSSSSS");

  // Calculate the time difference in milliseconds
  let timeDiff = formatTimeToMoment(selTim[0].RunTime).diff(
    formatTimeToMoment(selrtime.RunTime)
  );

  // Format the time difference
  const formatTimeDiff = (diff: number) => {
    const duration = moment.duration(diff);
    const hours = Math.floor(duration.asHours());
    const mins = duration.minutes();
    const secs = duration.seconds();
    const millis = duration.milliseconds();
    return `${hours < 10 ? "0" : ""}${hours}:${mins < 10 ? "0" : ""}${mins}:${
      secs < 10 ? "0" : ""
    }${secs}.${millis}`;
  };

  // Format the time, including negative sign if needed
  let formattedTime = formatTime(formatTimeDiff(Math.abs(timeDiff)), "S");
  if (timeDiff < 0) {
    formattedTime = "-" + formattedTime;
  } else {
    formattedTime = "+" + formattedTime;
  }

  let timdiff: TimeDiffDTO = {
    rnk: rnk,
    text: `${rnk}:`,
    time: formattedTime,
    trend: false,
    before: timeDiff < 0 ? true : false,
    timeMS: Math.abs(timeDiff) ,
    closest: false,
  };

  return timdiff;
}

export interface TimeDiffDTO {
  rnk: number;
  text: string;
  time: string;
  timeMS: number;
  trend: boolean;
  before: boolean;
  closest: boolean;
}
